/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, Fragment } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarText,
  UncontrolledDropdown
} from "reactstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { store } from "../../reduxStore/store";
import { logOutUser } from "../../reduxStore/actions/auth";
import { notificationNumber } from "../../reduxStore/actions/commonAction";
import FullLogo from "../../assets/images/web-logo.png";
import SmallLogo from "./../../assets/images/logo-small.png";
import SmallLogoWhite from "./../../assets/images/logo-small-white.png";
import Label from "./../../components/label";
import ATag from "./../../components/anchor";
import SearchInput from "./../../components/searchInput";
import { Link } from "react-router-dom";
import defaultUserPic from "../../assets/images/default-picture.png";
import appRoutes from "../../routes/appRoutes";
import ListItem from "@material-ui/core/ListItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import Anchor from "../../components/anchor";
import APP_CONSTANTS from "../../constants";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";

import MakeAPICall from "../../apiCalls/common";
import {
  changeVisibilityModeApiRoute,
  clearParticularNotification,
  doctorNotifications,
  getPatientRecordList,
  readAllNotification,
  readDoctorNotification,
  changePinAPI
} from "../../apiRoutes";
import Divider from "@material-ui/core/Divider";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import Model from "../../components/modal";
import CustomModel from "../../components/customModal";
import ChangePinForm from "../../containers/ChangePasswordForm/ChangePinForm";

class TopNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationListOpen: false,
      unreadNotification:
        store.getState().commonReducers.totalNotification || 0,
      notificationList: [],
      isGeneralPracticeGranted:  !!store.getState().auth.user?.userData?.templateChoices?.generalPractices,
      user:
        store.getState().auth &&
        store.getState().auth.user &&
        store.getState().auth.user.userData
          ? store.getState().auth.user.userData
          : {},
      appConstant:
        store.getState().auth &&
        store.getState().auth.user &&
        store.getState().auth.user.appConstant
          ? store.getState().auth.user.appConstant
          : {},
      apiCall: null,
      timeout: 0,
      patientSearchData: [],
      searchTextValue: "",
      searchText: false,
      patientSearchLoading: false,
      notificationListUpdate: false,
      patientOpen: false,
      onLineOfLineModal: false,
      goToAddAccount:
        props.auth &&
        props.auth.user &&
        props.auth.user.userData &&
        props.auth.user.userData.manageAccount &&
        props.auth.user.userData.manageAccount._id
          ? false
          : true,
      isInstantConsultAccessGranted: false,
      isInstantSwitchAccessGranted: false,
      isChangePinModelOpen: false,
    };
  }

  logOut = async () => {
    let token = "";
    let id = "";
    if (this.props.auth.user && this.props.auth.user.userData) {
      token = this.props.auth.user.userData.accessToken;
      id = this.props.auth.user.userData.doctorId;
    }

    await this.props.logOutUser({
      token: token,
      id: id
    });
  };

  /* 
    Toggle notification popup
  */
  toggleNotificationListOpen = () => {
    this.setState({ notificationListOpen: !this.state.notificationListOpen });
    this.getAllNotifications();
  };

  componentDidMount() {
    //console.log("Navbar data: ", this.props.commonReducers);
    if (
      store.getState().auth &&
      store.getState().auth.user &&
      store.getState().auth.user.userData
    ) {
      this.getAllNotifications();
      store.subscribe(() => {
        this.setState({
          user:
            store.getState().auth.user && store.getState().auth.user.userData
              ? store.getState().auth.user.userData
              : {},
          unreadNotification: store.getState().commonReducers.totalNotification
            ? store.getState().commonReducers.totalNotification
            : 0,
          isGeneralPracticeGranted:  !!store.getState().auth.user?.userData?.templateChoices?.generalPractices,
          isInstantConsultAccessGranted: store.getState().commonReducers.accessGranted.isInstantConsultAccessGranted,
          isInstantSwitchAccessGranted: store.getState().commonReducers.accessGranted.isInstantSwitchAccessGranted
        });
      });
    } else {
      this.logOut();
    }
  }

  componentDidUpdate(prevProp, prevState) {
    if (prevState.unreadNotification !== this.state.unreadNotification)
      this.getAllNotifications();
  }

  notificationNumber = async data => {
    await this.props.notificationNumber({
      totalNotification: data
    });
  };

  /* 
    Get all notification list when component loads
  */

  getAllNotifications = () => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: doctorNotifications,
      dataObj: {},
      params: {
        limit: 0,
        skip: 0,
        hasHistoryNotifications: false,
        isOnlyUnread: true
      },
      headers: {},
      successCallback: res => {
        this.setState({
          notificationList: res.data.data.notifications
        });
        this.notificationNumber(res.data.data.unReadCount);
      },
      failureCallback: err => {
        //console.log("Error API Call : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  /* 
    Read particular notification - on click
  */

  readNotificaiton = (e, val) => {
    e.stopPropagation();
    console.log(val);
    let apiCallParam = {
      reqType: "PUT",
      reqURL: readDoctorNotification + val._id,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: () => {
        this.toggleNotificationListOpen();
        if(val.isTicket && val.isTicket === true) {
          this.props.history.push(appRoutes.editTicket + "/" + val.ticketId, { _id: val.ticketId });
        }
        else {
          this.props.history.push(appRoutes.notifications);
        }
      },
      failureCallback: err => {
        //console.log("Error API Call : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  clearParticularNotifi = (e, val) => {
    e.stopPropagation();
    console.log("Clearing this notification: ", val);
    let apiCallParam = {
      reqType: "post",
      reqURL: clearParticularNotification,
      dataObj: { notificationId: val._id },
      params: {},
      headers: {},
      successCallback: res => {
        this.toggleNotificationListOpen();
        this.getAllNotifications();
        console.log("Is a ticket here? ", val);
        if (val.isTicket && val.isTicket === true) {
          this.props.history.push(appRoutes.editTicket + "/" + val.ticketId, { _id: val.ticketId });
        }
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };


  /* 
    Read notification on click - All read
  */

  markAsReadAllNotification = () => {
    let apiCallParam = {
      reqType: "PUT",
      reqURL: readAllNotification,
      dataObj: {
        status: 1
      },
      params: {},
      headers: {},
      successCallback: this.getAllNotifications,
      failureCallback: err => {
        console.log("Error API Call : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  handleSearchInput = event => {
    this.setState({
      searchTextValue: event.target.value
    });
  };

  viewHistory = () => {
    this.props.history.push(appRoutes.notifications, {
      viewHistory: true
    });
  }

  viewCurrentNotifications = () => {
    this.props.history.push(appRoutes.notifications, {
      viewHistory: false
    });
  }

  /* 
    Track user typing
  */

  searchPatientRecord = event => {
    var searchText = event.target.value; // this is the search text

    if (this.state.timeout) clearTimeout(this.state.timeout);
    this.setState({
      timeout: setTimeout(() => {
        if (searchText.trim().length && searchText.trim().length > 2) {
          this.setState({ patientSearchLoading: true, patientOpen: true });
          this.getPatientRecords(searchText);
        } else {
          this.setState({
            searchText: false,
            patientSearchData: [],
            patientSearchLoading: false,
            patientOpen: false
          });
        }
      }, 700)
    });
  };

  /* 
    Search Patient API Call after user typing
  */

  getPatientRecords = searchText => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: getPatientRecordList,
      dataObj: {},
      params: {
        searchParam: searchText
      },
      headers: {},
      successCallback: res => {
        if (!res.data.data.patients.length)
          this.setState({
            searchText: true,
            patientSearchLoading: false
          });

        this.setState({
          patientSearchData: res.data.data.patients
        });
      },
      failureCallback: err => {
        //console.log("Something went wrong, Please try again! ", err);
        this.setState({ patientSearchLoading: false, searchText: false });
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  /*
   * Go to Add Account page if don't have an account
   */

  gotToAddAccount = () => {
    this.setState({
      goToAddAccount: false
    });
    this.props.history.push(appRoutes.addBankDetails);
  };

  setSelectedPatient = pat => {
    const auth = this.props.auth.user.userData;
    window.open(
      APP_CONSTANTS.pmsURL +
        "/patient/patientDetails?accessToken=" +
        auth.accessToken +
        "&patientId=" +
        pat.id +
        "&searchType=DOCTOR" +
        "&adminName=" +
        auth.firstName +
        " " +
        auth.lastName,
      "_blank"
    );

    this.setState({
      patientSearchData: [],
      patientSearchLoading: false,
      patientOpen: false,
      searchTextValue: ""
    });
  };

  /*
   * Change doctor online status
   */

  changeDoctorOnlineStatus = event => {
    event.stopPropagation();
    this.setState({
      onLineOfLineModal: true
    });
  };

  changeOnlineStatus = () => {
    let changedState = null,
      bodyData = new FormData();
    if (
      this.props.commonReducers &&
      this.props.commonReducers.doctorOnlineState === true
    ) {
      changedState = false;
      bodyData.append("visibilityMode", false); // please don't confuse here, backend variable is visibilityMode and front-end using online
    } else {
      changedState = true;
      bodyData.append("visibilityMode", true); // so, visibilityMode is true then doctor is not online
    }

    let apiCallParamDoctorState = {
      reqType: "PUT",
      reqURL: changeVisibilityModeApiRoute,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: async res => {
        //console.log("Doctor visibilityMode state changed : ", changedState);
        this.props.commonReducers.doctorOnlineState = changedState;
        this.setState({
          onLineOfLineModal: false
        });
      },
      failureCallback: err => {
        //console.log("Something went wrong. Please try again : ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParamDoctorState
    });
  };

  cancelOnLineOfLineModal = () => {
    this.setState({
      onLineOfLineModal: false
    });
  };

  // ERX Requirement

  openChangePinDialog = () => {
    this.setState({
      isChangePinModelOpen: true
    });
  }

  handleChangePinSubmit = (data) => {
    console.log("Submit this data: ", data);
    let apiCallParamDoctorState = {
      reqType: "PUT",
      reqURL: changePinAPI,
      dataObj: data,
      params: {},
      headers: {},
      successCallback: async res => {
        console.log("Pin changed successfully");
        this.setState({
          isChangePinModelOpen: false
        });
      },
      failureCallback: err => {
        //console.log("Something went wrong. Please try again : ", err);
      },
      showPopUp: true,
    };
    this.setState({
      apiCall: apiCallParamDoctorState
    });
  }


  render() {
    return (
      <Fragment>
        <Navbar
          fixed="top"
          color="light"
          light
          expand="md"
          className="top-nav-container top-nav top-nav-loggedIn"
        >
          <NavbarBrand className="disabled-link">
            <img
              src={FullLogo}
              alt="Instant Consult Logo"
              className="d-none d-sm-block ic-logo"
            />
            <img
              src={SmallLogo}
              alt="Instant Consult Logo"
              className="d-block d-sm-none mx-auto"
            />
          </NavbarBrand>
          <div className="w-100 d-block d-sm-none"></div>


          <Nav className="mx-auto input-width" navbar>

            {
                <Fragment>
                  {/* User Input */}
                  <SearchInput
                    placeholder="Search Patient Records"
                    onKeyUp={this.searchPatientRecord}
                    value={this.state.searchTextValue}
                    onChange={this.handleSearchInput}
                  />
                  {this.state.patientOpen === true && (
                    <Fragment>
                      {/* Loading show */}
                      <div
                        className={
                          this.state.patientSearchLoading
                            ? "patient-search-list"
                            : "d-none"
                        }
                      >
                        <List component="nav" aria-label="secondary mailbox folders">
                          <ListItem className="">
                            <div className="row p-0 m-0 text-center w-100">
                              <div className="col-sm-12 p-0">
                                <CircularProgress
                                  disableShrink
                                  className="primary-loader"
                                />
                              </div>
                            </div>
                          </ListItem>
                        </List>
                      </div>

                      {/* Patient Search record show */}
                      <div
                        className={
                          this.state.patientSearchData.length
                            ? "patient-search-list"
                            : "d-none"
                        }
                      >
                        {this.state.patientSearchData &&
                          this.state.patientSearchData.map((values, index) => {
                            let patName = "";

                            patName = patName + values.firstName;

                            if (
                              values.middleName &&
                              values.middleName.trim().length > 0
                            ) {
                              patName = patName + " " + values.middleName;
                            }

                            if (
                              values.lastName &&
                              values.lastName.trim().length > 0
                            ) {
                              patName = patName + " " + values.lastName;
                            }

                            return (
                              <List
                                component="nav"
                                className="p-0"
                                key={index}
                                aria-label="secondary mailbox folders"
                              >
                                <ListItem className="p-3" button>
                                  <div
                                    onClick={e =>
                                      this.setSelectedPatient({
                                        id: values._id,
                                        name: patName
                                      })
                                    }
                                    className="row p-0 m-0 cursor-pointer"
                                  >
                                    <div className="col-sm-12 p-0 cursor-pointer">
                                      <span className="patient-search-name">
                                        {patName}
                                      </span>
                                    </div>
                                    <div className="col-sm-12 p-0 cursor-pointer">
                                      <span className="patient-search-desc">
                                        {values.gender}
                                      </span>
                                      <span className="patient-search-desc ml-3">
                                        DOB:{" "}
                                        {moment(
                                          values.dateOfBirth,
                                          "DD-MM-YYYY"
                                        ).format("Do MMM YYYY")}
                                      </span>
                                      <span className="patient-search-desc ml-3">
                                        UIN: {values.patientId}
                                      </span>
                                    </div>
                                  </div>
                                </ListItem>

                                <Divider />
                              </List>
                            );
                          })}
                      </div>
                    </Fragment>
                  )}

                  {/* No data found show */}
                  <div
                    className={
                      this.state.patientSearchData.length === 0 &&
                        this.state.searchText
                        ? "patient-search-list"
                        : "d-none"
                    }
                  >
                    <List component="nav" aria-label="secondary mailbox folders">
                      <ListItem className="" button>
                        <div className="row p-0 m-0">
                          <div className="col-sm-12 p-0">
                            <Label title="No Data Found" className="w-100 mb-0" />
                          </div>
                        </div>
                      </ListItem>

                      <Divider />
                    </List>
                  </div>
                </Fragment>
            }
          </Nav>

          {/* Support call and email */}
          <NavbarText className="ml-2 ipad-ml-3">
            <div>
              <div className="float-left">
                <Label title="Support" className="mr-2" />
                <i className="fas fa-phone-alt ipad-primary-color ipad-support-phone"></i>
                {this.state.appConstant.phoneNumber ? (
                  <ATag
                    title={
                      this.state.appConstant.phoneNumber.slice(0, 4) +
                      " " +
                      this.state.appConstant.phoneNumber.slice(4, 7) +
                      " " +
                      this.state.appConstant.phoneNumber.slice(7, 10)
                    }
                    href={"tel:" + this.state.appConstant.phoneNumber}
                    className="insta-link-orange mr-3 thin-font ipad-d-none"
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="w-100 d-block d-sm-none"></div>
              <div className="float-left">
                <i className="fas fa-envelope mr-1 ipad-primary-color ipad-support-email"></i>
                {this.state.appConstant.email ? (
                  <ATag
                    href={"mailTo:" + this.state.appConstant.email}
                    className="insta-link-orange thin-font ipad-d-none"
                    title={this.state.appConstant.email}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </NavbarText>

          {/* User Profile dropdown */}
          <div className="top-nav-right">
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                <img
                  className="rounded-circle user-pic"
                  src={
                    this.state.user.profilePic &&
                    this.state.user.profilePic.original
                      ? this.state.user.profilePic.original
                      : defaultUserPic
                  }
                  alt="user-pic"
                />
                <span className="ipad-d-none ipad-portrait-d-none">{this.state.user.firstName + " " + this.state.user.lastName}</span>
                {this.state.isGeneralPracticeGranted && <div className={
                    this.props.commonReducers &&
                    this.props.commonReducers.doctorOnlineState === false
                      ? "loaderIn"
                      : "loaderInGreen"
                  }
                  onClick={event => this.changeDoctorOnlineStatus(event)}
                >
                  <div className={
                      this.props.commonReducers &&
                      this.props.commonReducers.doctorOnlineState === false
                        ? "loader"
                        : "loaderGrren"
                    }
                  />
                </div>
                }
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem className="top-nav-list-item">
                  <Link to={""}>
                    <span>My Ratings</span>
                    <Box component="fieldset" borderColor="transparent">
                      <Rating
                        name="rating"
                        value={parseFloat(
                          this.state.user && this.state.user.avgRating
                            ? this.state.user.avgRating
                            : 0
                        ).toFixed(1)}
                        precision={0.5}
                        readOnly
                      />
                    </Box>
                    {/* <div>
                      {this.state.user && this.state.user.avgRating
                        ? [1, 2, 3, 4, 5].map(number => {
                            return (
                              <i
                                key={number}
                                className={
                                  number <= Math.floor()
                                    ? "fas fa-star rating-star"
                                    : "fas fa-star rating-star-gray"
                                }
                              ></i>
                            );
                          })
                        : ""}
                    </div> */}
                  </Link>
                </DropdownItem>
                <DropdownItem className="top-nav-list-item">
                  <Link to={appRoutes.profile}>
                    <i className="fas fa-user"></i>&nbsp;&nbsp;&nbsp;My Profile
                  </Link>
                </DropdownItem>
                <DropdownItem className="top-nav-list-item">
                  <Link to={appRoutes.changePassword}>
                    <i className="fa fa-lock"></i>&nbsp;&nbsp;&nbsp;Change
                    Password
                  </Link>
                </DropdownItem>
                {/* <DropdownItem className="top-nav-list-item" onClick={this.openChangePinDialog}>

                  <i className="fa fa-lock"></i>&nbsp;&nbsp;&nbsp;Change
                  Pin

                </DropdownItem> */}
                <DropdownItem
                  className="top-nav-list-item"
                  onClick={this.logOut}
                >
                  <i className="fas fa-sign-out-alt"></i>
                  &nbsp;&nbsp;&nbsp;Logout
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <div
              className={
                this.props.commonReducers &&
                (this.props.commonReducers.appointmentData || this.props.commonReducers.isOnlineAssessmentStarted)
                  ? "d-none"
                  : "notification-div cursor-pointer"
              }
              onClick={this.toggleNotificationListOpen}
            >
              <i className="fas fa-bell mt-3 mr-3 ml-2 cursor-pointer bell-icon"></i>
              <span
                className={
                  this.state.unreadNotification > 0 ? "count" : "d-none"
                }
              >
                {this.state.unreadNotification}
              </span>
              <div className="notification-list">
                <div
                  className={
                    this.state.notificationListOpen ? "after-block" : "d-none"
                  }
                >
                  <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                      <ListSubheader component="div" id="nested-list-subheader">
                        <div onClick={this.viewHistory} className="float-left">
                          <Anchor
                            title="View History"
                            className="cursor-pointer font-14"
                          />
                        </div>
                        <div onClick={this.viewCurrentNotifications}>
                          <Anchor
                            title="View Current Notifications"
                            className="cursor-pointer insta-link-orange font-14"
                          />
                        </div>
                      </ListSubheader>
                    }
                  >
                    {this.state.notificationList.map((value, index) => {
                      return (
                        <ListItem
                          className={value.isRead ? "" : "unread-chat"}
                          button
                          key={value._id}
                          onClick={(e) => this.readNotificaiton(e, value)}
                        >
                          <img
                            src={SmallLogoWhite}
                            alt="ic-logo"
                            className="notification-logo cursor-pointer"
                          />
                          <div className="notification-text float-right">
                            <Label
                              title={value.notificationMsg}
                              className="secondary-font w-100 mb-0 cursor-pointer text-transform-initial"
                            />
                            <Label
                              title={moment(value.notificationDate).format(
                                "DD MMM YYYY"
                              )}
                              className="gray w-100 mb-0 cursor-pointer"
                            />
                          </div>
                        </ListItem>
                      );
                    })}

                    <ListItem
                      className={
                        this.state.unreadNotification !== 0 ? "d-none" : ""
                      }
                      button
                    >
                      <div className="notification-text w-100">
                        <Label
                          title="No data found"
                          className="secondary-font w-100 mb-0 cursor-pointer text-center text-transform-initial"
                        />
                      </div>
                    </ListItem>
                  </List>
                </div>

                {/* <ListItem button>
                  <ListItemText primary={`Item 1`} />
                </ListItem>                 */}
              </div>
            </div>
          </div>
        </Navbar>

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Go to Add Account Model if don't have account */}
        <Model
          openModal={this.state.goToAddAccount}
          modalBodyContent="Please add your bank details before <br/> being able to accept consult requests"
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.gotToAddAccount}
          cancelEvent={this.gotToAddAccount}
        />
        {/* Online and Offline model */}
        <Model
          openModal={this.state.onLineOfLineModal}
          modalBodyContent={
            this.props.commonReducers.doctorOnlineState
              ? "Would you like to Appear Offline? <br/> You will be unable to accept Consult Requests"
              : "Would you like to Appear Online? <br/> You can then accept Consult Requests"
          }
          okayText="Yes"
          cancelText="No"
          title={
            this.props.commonReducers.doctorOnlineState
              ? "You're Online"
              : "You're Offline"
          }
          useOneButton={false}
          okayEvent={this.changeOnlineStatus}
          cancelEvent={this.cancelOnLineOfLineModal}
        />

        {/* Change PIN model */}
        <CustomModel
          openModal={this.state.isChangePinModelOpen}
          modalBodyContent={
            <ChangePinForm onFormSubmit={this.handleChangePinSubmit} closeModal={() => {
              this.setState({
                isChangePinModelOpen: false
              })
            }} />
          }
          okayText="Yes"
          cancelText="No"
          title={"Change PIN"
          }
          noFooterButtons={true}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = props => ({
  auth: props.auth,
  commonReducers: props.commonReducers
});

const mapDispatchToProps = dispatch => ({
  logOutUser: data => dispatch(logOutUser(data)),
  notificationNumber: data => dispatch(notificationNumber(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TopNavBar));
